const APK_UPDATE_URL = '/php/apkDownloadInfo.php';
const APK_UPDATE_INTERVAL = 5 * 60 * 1000;
const APK_LINK_SELECTOR = 'a[data-apk-download-link]';
const APK_DISABLED_TITLE = window.SITE_I18N?.apk_disabled_title || 'Download link is temporarily unavailable';

let apkDownloadUrl = null;

function getDownloadButton(link) {
    return link.querySelector('button');
}

function isHttpUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
        return false;
    }
}

function getUrlWithCacheBust(url) {
    const cacheBustedUrl = new URL(url, window.location.href);
    cacheBustedUrl.searchParams.set('_', Date.now());
    return cacheBustedUrl.toString();
}

function getUpdatedHref(currentHref, clientUrl) {
    const currentUrl = new URL(currentHref, window.location.href);

    if (currentUrl.hostname === 'app.adjust.com') {
        currentUrl.searchParams.set('redirect', clientUrl);
        return currentUrl.toString();
    }

    return clientUrl;
}

function applyApkDownloadUrl(clientUrl) {
    if (!clientUrl || clientUrl === apkDownloadUrl || !isHttpUrl(clientUrl)) {
        return;
    }

    apkDownloadUrl = clientUrl;

    document.querySelectorAll(APK_LINK_SELECTOR).forEach((link) => {
        const button = getDownloadButton(link);

        link.href = getUpdatedHref(link.href, clientUrl);
        link.removeAttribute('aria-disabled');
        link.removeAttribute('title');
        link.classList.remove('is-disabled');

        if (button) {
            button.disabled = false;
            button.removeAttribute('title');
        }
    });
}

function preventUnavailableDownload(event) {
    if (!apkDownloadUrl) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}

function disableDownloadLink(link) {
    const button = getDownloadButton(link);

    link.href = '#';
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('title', APK_DISABLED_TITLE);
    link.classList.add('is-disabled');
    link.addEventListener('click', preventUnavailableDownload, true);

    if (button) {
        button.disabled = true;
        button.setAttribute('title', APK_DISABLED_TITLE);
    }
}

function loadApkDownloadUrl() {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', getUrlWithCacheBust(APK_UPDATE_URL), true);

    xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
            return;
        }

        try {
            const data = JSON.parse(xhr.responseText || '{}');
            applyApkDownloadUrl(data.client_url);
        } catch (error) {
            return;
        }
    };

    xhr.onerror = function () {
        return null;
    };
    xhr.send();
}

function initApkDownloadLinkUpdate() {
    const links = document.querySelectorAll(APK_LINK_SELECTOR);

    if (!links.length) {
        return;
    }

    links.forEach((link) => {
        disableDownloadLink(link);
    });

    loadApkDownloadUrl();
    window.setInterval(loadApkDownloadUrl, APK_UPDATE_INTERVAL);
}

initApkDownloadLinkUpdate();
